/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CaptureImageSeries from 'DesignSystem/CaptureImageSeries/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CaptureImageRequest/Content/Content/IntraoralMobileCapture/Content"
  
}) {
let imagesRequestCreateIdValueData = fromData.useDataValue({ viewPath,
context: 'images_request_create',
path: 'id',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="100%"
 width="100%"
 paddingBottom={0}
 paddingTop={0}
 paddingRight={0}
 paddingLeft={0}
>
{childProps => (
<CaptureImageSeries
{...childProps}
  viewPath={`${viewPath}/CaptureImageSeries`}
 data="images_request_create.id"
 imagesRequestId={imagesRequestCreateIdValueData}
/>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}